import { SearchIcon } from '../assets/svgImages';
import { CATEGORY_KEY_SEPARATOR } from '../constant/constant';
import { SelectedFilters } from '../interface/interface';

// Category keys are stored as full paths, so show only the last segment.
const lastSegment = (key: string) =>
  key.split(CATEGORY_KEY_SEPARATOR).pop() ?? key;

const getSelectedLabels = (filters: SelectedFilters) => [
  ...filters.primaryCategories,
  ...filters.subCategories.map(lastSegment),
  ...filters.tertiaryCategories.map(lastSegment),
  ...filters.conditions,
  ...(filters.brands ?? []),
];

const NoProductsFound = ({
  filters,
  onClearFilters,
}: {
  filters: SelectedFilters;
  onClearFilters: () => void;
}) => {
  const selectedLabels = getSelectedLabels(filters);
  const hasFilters = selectedLabels.length > 0;

  return (
    <div
      className="flex flex-col items-center justify-center text-center rounded-xl border border-dashed border-grey-300
        bg-white px-6 py-12 md:py-16"
    >
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-secondary-pink-50 mb-4">
        <SearchIcon className="w-7 h-7 text-primary-blue-500" />
      </div>

      <h3 className="text-lg md:text-xl font-semibold text-primary-blue-500">
        No products found
      </h3>

      {hasFilters ? (
        <>
          <p className="mt-2 text-sm text-gray-500 max-w-md">
            We couldn&apos;t find any products matching your selected category.
            Try removing a category or browse our full range of shop products.
          </p>

          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {selectedLabels.map((label) => (
              <span
                key={label}
                className="text-xs font-medium text-primary-blue-500 bg-primary-blue-50 border border-primary-blue-100 rounded-full px-3 py-1"
              >
                {label}
              </span>
            ))}
          </div>

          <button
            type="button"
            onClick={onClearFilters}
            className="mt-6 rounded-full bg-primary-blue-500 px-8 py-3 text-sm font-semibold text-white hover:bg-white hover:text-primary-blue-500 transition-colors"
          >
            Clear
          </button>
        </>
      ) : (
        <p className="mt-2 text-sm text-gray-500 max-w-md">
          There are no products available right now. Please check back soon.
        </p>
      )}
    </div>
  );
};

export default NoProductsFound;
